// extracted by mini-css-extract-plugin
module.exports = {"LegalDisclaimer_contentCard":"LegalDisclaimer_LegalDisclaimer_contentCard__3qIjr","Content":"LegalDisclaimer_Content__1VHo4"};